<div class="code-entry-container">
  <div class="title-container">
    <h5>Enter your property code here</h5>
    <ng-container *ngIf="errorMessage">
        <div class="error-text input-msg">
          {{ errorMessage }}
        </div>
    </ng-container>
  </div>

<ng-container *ngIf="validationResult && validationResult.isValid">
    <div class="success-text input-msg">Reference Code Confirmed!</div>
</ng-container>

  <div class="responsive-container">
  <div class="flx-container oa-flex">
    <div class="flx-left">
      <input
      #inputCodeFirst4Chars
      id="input-codeFirst4Chars"
      maxlength="4"
      class="form-control code-input"
      type="text"
      [(ngModel)]="codeFirst4Chars"
      (ngModelChange)="onCodeChange('input-codeFirst4Chars', $event)"
      (paste)="onPaste($event)"
      />
    </div>
    
    <div class="flx-item flx-center">―</div>
    
    <div class="flx-item">
      <input
      #inputCodeLast4Chars
      id="input-codeLast4Chars"
      maxlength="4"
      class="form-control code-input"
      type="text"
      [(ngModel)]="codeLast4Chars"
      (ngModelChange)="onCodeChange('input-codeLast4Chars', $event)"
      />
    </div>
  </div>
    <div class="flx-item">
      <button
      id="code-entry-go-button"
      [disabled]="!validationResult || !validationResult.isValid"
      class="btn btn-primary btn-round hvr-push el-100px"
      (click)="onProceed()"
      >
      Go
    </button>
  </div>

  <div *ngIf="showNoCodeButton" class="flx-item">
    <button id="no-code-button" class="btn btn-primary btn-round hvr-push" (click)="onNoCodeClick()">I don't have a code.</button>
  </div>
  </div>
</div>